import { translate } from 'game/translate';
import { Container, Text } from 'pixi.js';
import { tutorialButtonsStyle } from './fileStyle';
import { Displays } from 'constants/layout';
import { Layout } from 'game/LayoutManager';

export class UIButton {
    container: Container;
    text: Text;
    action: () => void;

    constructor(label: string, action: () => void) {
        this.action = action;
        this.container = new Container();
        this.container.eventMode = 'static';
        this.container.cursor = 'pointer';
        this.container.label = label;
        this.container.on('pointerdown', this.onClick.bind(this));
        this.text = new Text({ text: translate(label), style: tutorialButtonsStyle });
        this.text.anchor.set(0.5);
        this.container.addChild(this.text);
    }
    onClick() {
        this.action();
    }
    adjustFontSizeByDevice() {
        switch (Layout.getDisplay()) {
            case Displays.DESKTOP:
                this.text.style.fontSize = 19;
                this.text.anchor.set(0.5);
                break;
            case Displays.TABLET:
                this.text.style.fontSize = 20;
                this.text.anchor.set(1, 0.5);
                break;
            case Displays.MOBILE:
                this.text.style.fontSize = 12;
                this.text.anchor.set(1, 0.5);
                break;
        }
        this.text.x = 0; // -this.text.width / 2;
        this.text.y = 0; // -this.text.height / 2;
    }
}
